import React from 'react';

const NAV = [
  { id: 'summary', label: 'At a glance' },
  { id: 'sentence', label: 'One sentence' },
  { id: 'corepattern', label: 'Core pattern' },
  { id: 'core', label: 'Core numbers' },
  { id: 'patterns', label: 'Repeating patterns' },
  { id: 'tension', label: 'Tension' },
  { id: 'life', label: 'Life areas' },
  { id: 'cycle', label: 'Timing' },
  { id: 'focus', label: 'Focus now' },
  { id: 'prompts', label: 'Reflection' },
  { id: 'method', label: 'How built' },
  { id: 'advanced', label: 'Advanced topics' },
];

export default function NumerologyReportNav({ sectionIds }) {
  const allowed = new Set(sectionIds || []);
  const items = NAV.filter((n) => allowed.has(n.id));

  if (!items.length) return null;

  return (
    <nav className="amm-num-nav" aria-label="Report sections">
      <p className="amm-num-nav-label">On this page</p>
      <ul className="amm-num-nav-list">
        {items.map((it) => (
          <li key={it.id}>
            <a href={`#amm-section-${it.id}`}>{it.label}</a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
